import 'slick-carousel/slick/slick.min';
import 'jquery-match-height/dist/jquery.matchHeight-min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';

export class WpetSingleCpnt {
    constructor()
    {
        this.initializeTourism();
        this.initializeToggleTitle();
        this.initializeSlick();
        this.initializeDetail();
        this.initializeAnchor();
    }
    
    initializeTourism() {
        let jstoggleMap = $('.js-toggleMap'),
            jscloseMap = $('.js-wpetMobileMapClose');
        
        jstoggleMap.on('click', function (e) {
            e.preventDefault();
            $('.wpetMobileMap').show();
            window.wpet_map_object.mapObject.resize();
            window.wpet_map_object.mapObject.fitBounds(window.wpet_map_object.bounds);
        });
        
        jscloseMap.on('click', function (e) {
            e.preventDefault();
            $('.wpetMobileMap').hide();
        });
        
        // let strate = document.querySelectorAll('.wpetStrate'),
        //     strateTitles = document.querySelectorAll('.wpetStrateTitle');
        //
        // strateTitles.forEach(strateTitle => strateTitle.addEventListener('click', (e) => {
        //     e.currentTarget.parentNode.classList.toggle('open');
        //     e.currentTarget.classList.toggle('open');
        // }));
    }

    initializeToggleTitle()
    {
        let $trigger = $('.wpetStrateTitle'),
            element  = $('.wpetStrate');

        $trigger.each( function () {
            $( this ).on( 'click', function () {
                $( this ).parents( element ).toggleClass( 'open' );
                $( this ).toggleClass( 'open' );
            } );
        } );
    }

    initializeSlick()
    {
        //Slick table period
        let $wpetTable = $('.wpetTableList');
        if ( $wpetTable.length > 0 ) {
            $wpetTable.slick({
                slide: '.wpetTableContainer',
                slidesToShow: 1,
                arrows: true,
                dots: false,
                infinite: false,
            });
        }

        // Slick gallery
        let $wpetGalleryItem = $('.js-wpetGallery');
        if ( $wpetGalleryItem.length > 0 ) {

            $wpetGalleryItem.slick({
                slide: '.wpetGalleryItem',
                speed: 1000,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                arrows: true,
                dots: false,
                variableWidth: true,
                centerMode: true,
            });
        }
        $('.wpetGallery .slick-slide.slick-cloned a').removeAttr("data-fancybox");
    }
    
    initializeDetail() {
        if ( window.matchMedia( "(max-width: 739px)" ).matches ) {
            $( '.wpetStrate .wpetStrateTitle' ).on( 'click', function () {
                $( this ).parent().toggleClass( 'close' );
            } );
        }
    }
    
    initializeAnchor() {
        function getIdActive(partsItem, wrapperNav, navItem, shift) {
            
            shift = (
                        typeof shift !== 'undefined'
                    ) ? shift : 0;
            
            var itemOffset = {};
            var idActive = '';
            
            $.each(partsItem, function () {
                itemOffset[$(this).attr('id')] = $(this).offset().top;
            });
            
            $(window).scroll(function () {
                var navOffset = wrapperNav.offset().top;
                
                for (var id in itemOffset) {
                    
                    if (itemOffset[id] < (
                        navItem.find('a[href="#' + id + '"]').offset().top + shift
                    )) {
                        
                        idActive = id;
                    }
                }
                
                if (itemOffset[Object.keys(itemOffset)[0]] > (
                    navItem.find('a[href="#' + id + '"]').offset().top + shift
                )) {
                    
                    navItem.find('a').removeClass('active');
                    
                } else {
                    
                    navItem.find('a').removeClass('active');
                    navItem.find('a[href="#' + idActive + '"]').addClass('active');
                }
            });
        };
        
        if (!Modernizr.touchevents) {
            $(window).load(function () {
                if ($('[data-nav-item]').length > 0) {
                    getIdActive($('.wpetStrate'), $('[data-nav-list]'), $('[data-nav-item]'));
                }
            });
        }
        
        if (window.matchMedia("(max-width: 739px)").matches) {
            
            $('.anchorItem a').on('click', function () {
                let target = $(this).attr('href');
                $(target).removeClass('close');
            });
            
        }
    }
    
    
}
